import React, { useState } from "react";
import "../../../../../src/style/block.scss";
import "./style.scss";
import "../../../../../src/style/buttons.scss";
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from "react-icons/md";
import ModalComponent from "../../../../features/ModalComponent";
import SortModal from "./sortModal";
import useAdditionalHooks from "../hooks/useAdditionalHooks";
import { useTranslation } from "react-i18next";
import getId from "../../../../utils/getId";

interface IProps {
  nextWeek: () => void;
  previousWeek: () => void;
  resetSortByExerciseGroup: () => void;
  sortByExerciseGroup: (value: number) => void;
  dateFromState: Date;
  dateToState: Date;
}

const ExerciseBarMobile: React.FC<IProps> = ({
  nextWeek,
  previousWeek,
  dateFromState,
  dateToState,
  sortByExerciseGroup,
  resetSortByExerciseGroup,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { getExerciseGroups, exerciseGroups, setSelectedExerciseGroupId, selectedExerciseGroupId } = useAdditionalHooks(
    sortByExerciseGroup,
    resetSortByExerciseGroup,
    dateFromState, dateToState
  );

  return (
    <React.Fragment>
      <div className="schedule-bar desktop">
        <div className="flex-between-center">
          <button
            onClick={() => {
              previousWeek();
            }}
            className="button medium button-fill-background-main"
          >
            <MdOutlineKeyboardArrowLeft className="icon" />
          </button>

          <button
            onClick={() => {
              nextWeek();
            }}
            className="button medium button-fill-background-main"
          >
            <MdOutlineKeyboardArrowRight className="icon" />
          </button>

          <button
            onClick={() => {
              setOpen(true);
              getExerciseGroups();
            }}
            className="button medium button-fill-background-main padding-medium"
          >
            {getId(selectedExerciseGroupId) ? `${t("wybrano")} ${selectedExerciseGroupId.name}` : t("wybierz_zajecia")}
          </button>
        </div>
      </div>
      {open && (
        <ModalComponent
          footer={true}
          open={open}
          closeModal={() => setOpen(false)}
          title={t("wybierz_zajecia")}
          onAccept={() => setOpen(false)}
        >
          <SortModal
            exerciseGroups={exerciseGroups}
            onSelect={(value) => setSelectedExerciseGroupId(value)}
          />
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

export default ExerciseBarMobile;
